<template>
  <div class="hcl-tiles-renderer">
    <div class="form-row row-fix" v-for="row of tilesRowsArray" :key="row">
      <hcl-tiles-tile v-for="tile in tilesOnFormPerRow(row)" :key="tile.id" :tile="tile"
        :dimensions="props.tiles.dimensions" :render="true" v-on:hcl-tiles-tile-change-height="onTilesTileChangeHeight"
        v-on:hcl-form-input-enter-key="onFormInputEnterKey" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onUpdated } from 'vue'

import HclTilesTile from '@/components/TilesTile/TilesTile.vue'

import { useUtils } from '@/components/TilesEditor/utils'
import { DefinitionTiles } from '../types'

interface Props {
  /**
   * Definition as an JS object.
   */
  tiles: DefinitionTiles
}

const props = withDefaults(defineProps<Props>(), {
  tiles: undefined
})

const {
  tilesOnFormPerRow,
  tilesRowsArray
} = useUtils(props)

onUpdated(() => {
  if (typeof $ !== 'undefined') {
    $(document).trigger('hcl.hcl-widgets-reparse', 'hcl-block-content-search-form')
  }
})

const emit = defineEmits(['hcl-tiles-tile-change-height', 'hcl-form-input-enter-key'])

const onTilesTileChangeHeight = (event: any) => {
  emit('hcl-tiles-tile-change-height', event)
}

const onFormInputEnterKey = (event: any) => {
  emit('hcl-form-input-enter-key', event)
}
</script>

<style lang="scss">
.hcl-tiles-renderer {
  width: 100%;

  .row-fix {
    margin: 0;
  }
}
</style>
